import React from "react";
import { finApi, money, BUCKET_LABEL } from "@/lib/financeApi";
import { Empty, ErrorBox, Loading, useLoad, when } from "@/components/nds/windows/finance/parts";

/** Read-only ledger rows (fin_transactions) shared by Outside income and Savings balance tabs. */
export function TxTable({ testid, items }) {
  return (
    <div className="border border-white/10 rounded-sm overflow-x-auto">
      <table data-testid={testid} className="w-full text-left">
        <thead><tr className="font-mono text-[9px] tracking-[0.16em] uppercase text-nex-muted">
          {["Date", "Type", "Bucket", "Description", "Amount", "Balance after"].map((h, i) => <th key={h} className={`px-3 py-2 font-normal ${i > 3 ? "text-right" : ""}`}>{h}</th>)}
        </tr></thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.id} data-testid={`${testid}-row-${t.id}`} className="border-t border-white/5">
              <td className="px-3 py-2 font-mono text-[10px] text-nex-muted whitespace-nowrap">{when(t.created_at)}</td>
              <td className="px-3 py-2 text-xs text-nex-silver">{t.type.replace(/_/g, " ")}</td>
              <td className="px-3 py-2 font-mono text-[10px] uppercase text-nex-muted">{BUCKET_LABEL[t.bucket] || t.bucket}</td>
              <td className="px-3 py-2 text-xs text-nex-muted max-w-[220px] truncate" title={t.description}>{t.description || "—"}</td>
              <td className={`px-3 py-2 font-mono text-xs text-right ${t.direction === "credit" ? "text-emerald-300" : "text-red-300"}`}>{t.direction === "credit" ? "+" : "−"}{money(t.amount)}</td>
              <td className="px-3 py-2 font-mono text-xs text-right text-nex-silver">{money(t.balance_after)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function OutsideIncomeTab({ resident }) {
  const [state, load] = useLoad(() => finApi.get("/transactions", { resident_id: resident.id, type: "outside_income", page_size: 500 }), [resident.id]);
  if (state.loading && !state.data) return <Loading testid="fin-outside-loading" />;
  if (state.error) return <ErrorBox testid="fin-outside-error" error={state.error} onRetry={load} />;
  if (!state.data.items.length) return <Empty testid="fin-outside-empty">No outside income posted yet.</Empty>;
  const total = state.data.items.reduce((a, t) => a + t.amount, 0);
  return (
    <div data-testid="fin-outside-tab" className="p-5 space-y-3">
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">{state.data.total} rows · <span data-testid="fin-outside-total" className="text-nex-gold">{money(total)}</span> total</div>
      <TxTable testid="fin-outside-table" items={state.data.items} />
    </div>
  );
}
